import React from "react";
import { motion } from "framer-motion";
import { MapPin, Clock, Sparkles, Users, Award } from "lucide-react";

const WhyChooseUsSection = () => {
  const features = [
    { icon: MapPin, title: "We Come To You", desc: "Home, work, anywhere in Melbourne" },
    { icon: Clock, title: "Flexible Scheduling", desc: "Book a time that works for you" },
    { icon: Sparkles, title: "Premium Products", desc: "Only the best for your vehicle" },
    { icon: Users, title: "Passionate Team", desc: "We love what we do" },
    { icon: Award, title: "Satisfied Customers", desc: "Quality service guaranteed" }
  ];

  return (
    <section className="section-spacing bg-slate-950" data-testid="why-choose-section">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Why Choose <span className="gradient-text">RainXpress</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6">
          {features.map((feature, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className="glass rounded-xl p-4 md:p-6 text-center card-hover"
            >
              <feature.icon className="w-8 h-8 text-cyan-400 mx-auto mb-3" />
              <h3 className="font-bold text-sm md:text-base mb-1">{feature.title}</h3>
              <p className="text-slate-400 text-xs md:text-sm">{feature.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUsSection;
